import rules from "@/utils/rules";
import {Toast} from "vant";
import {Message} from "element-ui";
import {IMAGE_PATH} from "@/config";

export const TOAST = {
  success: 'success',
  error: 'error'
}

export const loading = (msg = '正在加载...') => {
  Toast.loading({message: msg, forbidClick: true, duration: 0});
}
export const loaded = () => {
  Toast.clear()
}

export const toast = (msg, type = TOAST.success) => {
  if (browserRedirect() === 1) {
    Toast(msg)
  } else {
    if (type === TOAST.success) {
      Message.success({message: msg, duration: 2500})
    } else {
      Message.error({message: msg, duration: 2500})
    }
  }
}

export const  getStringByteLen =(val)=>{
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    let a = val.charAt(i);
    if (a.match(/[^\\x00-\\xff]/ig) != null) {
      len += 1;
    } else {
      len += 1;
    }
  }
  return len;
}



/**
 * 获取Token
 */
export const getToken = () => {
  let user = JSON.parse(window.localStorage.getItem('user'))
  return user ? {mid: user.mid ? user.mid : user.parent_id, sign: user.sign, fhid: user.fhid} : '';
}
/**
 * 获取Token
 */
export const getUser = () => {
  let user = JSON.parse(window.localStorage.getItem('user'))
  return user
}

/**
 * 百度编辑器配置
 * @returns
 */
export const bdEditConfig = () => {
  return {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 320,
    // 初始容器宽度
    initialFrameWidth: '100%',
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    // serverUrl: requestUrl + '/editor/controller.php',
    serverUrl: IMAGE_PATH + 'editor/controller.php',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
    UEDITOR_HOME_URL: '/vw/UEditor/'
  }
}

/*
 * 数据过滤全部
 * */
export const formatHtml = (str) => {
  const pattern = /<(\S*?)[^>]*>.*?|<.*? > /ig
  return str.replace(pattern, '').replace(/&nbsp;/ig, "")
}

export const getQueryString = (name) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
}
/***
 * 用来统一设置自定义信息
 * @param list 自定义信息数组
 * @param options 级别分类数组
 * @param morgname 总会的机构名称，接口没有返回总会，所以需要自己处理
 * @param organizs 分会的分类数组 为空时是分会有可能是总会，organiz_id 0 时是总会
 * @param organiz_id 分会不可以选择所属协会 该值传入则不可编辑 非 0 ，如果
 * @param isFieldShow 分会不可以选择所属协会 该值传入则不可编辑 除了 设置信息都不展示的
 * @returns {*}
 */
export const patternChange = (list, options, morgname = '', organizs = [], organiz_id = 0,isFieldShow = false) => {
  list.map(item => {
    if (item.title === '法人联系电话' || item.title === '联系人电话' || item.title === '会员电话') {
      item.rules = rules.tel
    }
    if (item.field === 'rankId') {
      item.options = options
      if (options.length === 1) {
        item.answer = options[0].value
      }
      item.type = 3;
      item.field = 'rankId'
      item.isMust = true
      item.isSet = false
      item.rules = [{required: true, message: '请选择', trigger: 'change'}]
    }
    if (item.field === 'fenhui_id') {
      item.title = '所属协会/分支机构'
      item.answer = organiz_id // 总会时默认选中
      item.hide = organizs.length === 0 // 没有分会或者是分会的时候不显示这个字段
      item.disabled = organiz_id !== 0 // 分会时不能选
      item.options = [...[{
        value: organizs.length === 0 ? organiz_id : 0,
        label: morgname
      }], ...organizs]
    }
    if (item.field === 'company' && (item.title === '所属机构' || item.title === '工作单位')) {
      item.title = '工作单位'
      item.placeholder = '请输入工作单位，没有请填写 无'
    }
    if (item.field === 'company' && item.title === '机构名称') {
      item.title = '单位名称'
      item.placeholder = '请输入单位名称'
    }

    if (item.field === 'address' && item.title === '机构地址') {
      item.title = '单位地址'
      item.placeholder = '请输入单位地址'
    }



    if (item.field === 'unitNature') {
      item.title = '单位性质'
      item.placeholder = '请选择单位性质'
      item.options = [
        {value: 4, label: '民营企业'},
        {value: 3, label: '国有企业'},
        {value: 15, label: '合资企业'},
        {value: 10, label: '央企（国资委）'},
        {value: 11, label: '央企（地方）'},
        {value: 12, label: '外企（欧美日韩）'},
        {value: 13, label: '外企（港澳台）'},
        {value: 14, label: '外企（其他）'},
        {value: 18, label: '股份'},
        {value: 20, label: '企业'},
        {value: 16, label: '科研院所'},
        {value: 17, label: '行政单位'},
        {value: 1, label: '机关'},
        {value: 2, label: '事业单位'},
        {value: 5, label: '社会团体'},
        {value: 19, label: '社会服务机构'},
        {value: 6, label: '民办非企业单位'},
        {value: 7, label: '基金会'},
        {value: 8, label: '其他'}
      ]
    }
    // if (item.type === 8 && item.isMust) {
    //     item.rules = [{type: 'date', required: true, message: '请选择', trigger: 'change'}]
    // }
    let rule = item.isMust ? {required: true, message: '请输入', trigger: 'blur'} : ''
    switch (Number(item.pattern || 0)) {
      case 0 :
        item.rules = item.isMust ? item.rules : []
        break
      case 1 :
        item.rules = [rule, rules.phoneNum]
        break
      case 2 :
        item.rules = [rule, rules.money]
        break
      case 3 :
        item.rules = [rule, rules.email]
        break
      case 4 :
        item.rules = [rule, rules.webUrl]
        break
    }
    item.isFieldShow = item.isFieldShow === undefined || item.isFieldShow
  })
  return isFieldShow ? list : list.filter(f=>{ return f.isFieldShow})
}

/**
 * 数据过滤全部
 * @param {*} state
 * @param {*} arr
 * @returns
 */
export const optionList = (state, arr) => {
  if (state) {
    return arr
  } else {
    return arr.slice(1)
  }
}

/**
 * value转换为label
 * @param {*} val
 * @param {*} arr
 * @returns
 */
export const filesCN = (val, arr) => {
  let _str = arr.filter(item => val === item.value)
  return _str[0].label
}

/**
 * 制定权限权限判断
 */
export const isPower = (powers, type) => {
  if (powers.length === 0) return true
  return powers.some(bol => bol === type)
}
export const isPatternPower = (powers, type) => {
  if (powers.length === 0) return true
  return powers.some(bol => type.test(bol))
}

export const isYinYuePower = (oid) => {
  return oid === -928
}

/**
 * 时间转换
 * @param {*} date
 * @param {*} type
 * @returns
 */
export const zhDate = (date, type) => {
  let now = new Date(date)
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type === 1) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 2) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 3) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type === 4) {
    return year
  } else {
    return year + "-" + getzf(month) + "-" + getzf(day)
  }
}

export const isLastDate = (date, count) => {
  let now = new Date()
  return date - now.getTime() <= 1000 * 60 * 60 * 24 * count
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}


export const zhRmb = (num) => {
  if (Number(num) > 10000) {
    return (Number(num) / 10000).toFixed(2) + '万元'
  } else {
    return num + '元'
  }
}

export const getUrlBase64 = (url) => {
  return new Promise(resolve => {
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    let img = new Image()
    img.crossOrigin = 'anonymous' //允许跨域
    img.src = url
    img.onload = function () {
      canvas.height = 300
      canvas.width = 300
      ctx.drawImage(img, 0, 0, 300, 300)
      let dataURL = canvas.toDataURL('image/png')
      canvas = null
      resolve(dataURL)
    }
  })
}

export const browserRedirect = () => {   //  1 手机 2 pc
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    return 1
  } else {
    return 2
  }
}



const wxsdk = require('jweixin-module')
export const shareWx =(data,_title,_url,_image,_summary)=>{
  wxsdk.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId, // 必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.nonceStr, // 必填，生成签名的随机串
    signature: data.signature.toLowerCase(), // 必填，签名，见附录1
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","chooseWXPay"]
  });
  wxsdk.ready(function() {
    //获取“分享给朋友”按钮点击状态及自定义分享内容接口(即将废弃)
    wxsdk.updateAppMessageShareData({
      title: _title, // 分享标题
      desc: _summary, // 分享描述
      link: _url, // 分享链接
      imgUrl: _image, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    });

    //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口(即将废弃)
    wxsdk.updateTimelineShareData({
      title: _title, // 分享标题
      desc: _summary, // 分享描述
      link: _url, // 分享链接
      imgUrl: _image, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      }
    });
  });
}